module.exports = __webpack_public_path__ + "static/logo-e14f8202fc966163453f68aa707123f7.png";